import type { Breadcrumb, ErrorEvent } from '@sentry/angular';

export const personnummerMask = '[personnummer]';

// The same pattern as PersonnummerMaskingEnricher in the backend logs
const personnummer = /(?<![\w-])(?:\d{8}|\d{6})[-+]?\d{4}(?![\w-])/g;

function mask<T>(value: T): T {
  if (typeof value === 'string') {
    return value.replace(personnummer, personnummerMask) as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => mask(item)) as T;
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, mask(item)])) as T;
  }
  return value;
}

/** Sentry's beforeBreadcrumb: HTTP breadcrumbs carry the full request URL, which can hold a personnummer. */
export function maskBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
  return mask(breadcrumb);
}

/** Sentry's beforeSend: masks the event's messages, request URL and breadcrumbs before it leaves the browser. */
export function maskEvent(event: ErrorEvent): ErrorEvent {
  return mask(event);
}
